import "./Strategy.module.css";
import Header from "@/reusable_sections/Header";
import StrategicConsulting from "./sections/StrategicConsulting";
import TheBlueprint from "./sections/TheBlueprint";
import ComplianceSecurityFirst from "./sections/ComplianceSecurityFirst";
import Footer from "@/reusable_sections/Footer";
export default function StrategyPage() {
  return <div>
      <Header />
      <StrategicConsulting />
      <TheBlueprint />
      <ComplianceSecurityFirst />
      <Footer />
    </div>;
}